module.exports = __webpack_public_path__ + "static/img/qb.7fb6c657.png";